import React from 'react';

const LoginArrowSvg = () => (
    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.01198 6.97607L8 3.98805L5.01198 1.00003" stroke="#439ADE"/>
        <path opacity="0.5" d="M0.903581 7L3.8916 4.01198L0.903581 1.02396" stroke="#439ADE"/>
    </svg>
)

export default LoginArrowSvg